import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getFreeServicesRequests = createAsyncThunk(
  "contracts/getFreeServicesRequests",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query, owner, user } = args;
      const filter = filterRequest(args.filter);

      const params = [];
      if (page) params.push(`page=${page}`);
      if (size) params.push(`size=${size}`);
      if (query) params.push(`query=${query}`);
      if (owner) params.push(`owner=${owner}`);
      if (user) params.push(`user=${user}`);
      if (filter) params.push(filter);

      const queryString = params.length ? `?${params.join('&')}` : '';
      const { data } = await axiosInstance.get(`/requests/services${queryString}`);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateFreeServiceRequest = createAsyncThunk(
  "contracts/updateFreeServiceRequest",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/requests/services/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const contractsSlice = createSlice({
  name: "serviceRequests",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFreeServicesRequests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFreeServicesRequests.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
        state.error = null;
      })
      .addCase(getFreeServicesRequests.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateFreeServiceRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFreeServiceRequest.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data?.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateFreeServiceRequest.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default contractsSlice.reducer;